var swiperAll = document.querySelectorAll('swiper-container');
if (document.querySelectorAll('swiper-container').length > 0) {
    swiperAll.forEach(swiperElement => {
    Object.assign(swiperElement, {
        slidesPerView: `${swiperElement.dataset.mobileSlides}`,
        spaceBetween: 10,
        navigation: {
        enabled: true,
        nextEl: `#shopify-section-${swiperElement.id} .swiper-prev-next-button.next`,
        prevEl: `#shopify-section-${swiperElement.id} .swiper-prev-next-button.prev`,
        },
        breakpoints: {
        768: {
            slidesPerView: `${swiperElement.dataset.tabletSlides}`,
        },
        1024: {
            slidesPerView: `${swiperElement.dataset.desktopSlides}`,
        },
        },
    });

    swiperElement.initialize();

    swiperElement.swiper.on('resize', function () {
        swiperElement.swiper.update()
    });
    });
}